// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"q8-z","categoryName":"r8-z","categoryImage":"s8-z","categoryContent":"t8-z","bottomAligned":"u8-z"};